import { useState, useEffect } from 'react';
import { X, Lightbulb } from 'lucide-react';

const COACHMARK_STORAGE_PREFIX = 'spooker_cm_';

const isDismissed = (id) => localStorage.getItem(`${COACHMARK_STORAGE_PREFIX}${id}`) === 'true';
const dismiss = (id) => localStorage.setItem(`${COACHMARK_STORAGE_PREFIX}${id}`, 'true');

export const resetAllCoachmarks = () => {
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith(COACHMARK_STORAGE_PREFIX)) {
      localStorage.removeItem(key);
    }
  });
};

export const Coachmark = ({ id, text, className = '' }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Delay show for smooth entrance
    const timer = setTimeout(() => {
      if (!isDismissed(id)) setVisible(true);
    }, 800);
    return () => clearTimeout(timer);
  }, [id]);

  if (!visible) return null;

  return (
    <div
      className={`flex items-start gap-2.5 px-3.5 py-2.5 rounded-lg bg-neutral-900 text-white text-xs leading-relaxed animate-in fade-in slide-in-from-bottom-2 duration-300 ${className}`}
      data-testid={`coachmark-${id}`}
    >
      <Lightbulb className="h-3.5 w-3.5 text-amber-400 shrink-0 mt-0.5" strokeWidth={2} />
      <span className="flex-1">{text}</span>
      <button
        onClick={() => { dismiss(id); setVisible(false); }}
        className="text-neutral-400 hover:text-white transition-colors shrink-0"
        data-testid={`coachmark-dismiss-${id}`}
        aria-label="Sluiten"
      >
        <X className="h-3.5 w-3.5" strokeWidth={2} />
      </button>
    </div>
  );
};
